import { actions } from './action'

const initialState = {
  data: [],
  totalCount: null,
  pagination: {
    skip: 0,
    limit: 10,
  },
  templateType: [],
}

const fetchEmailTemplateState = (state = initialState, action) => {
  switch (action.type) {
    case actions.FETCH_EMAIL_TEMPLATE:
      return {
        ...state,
        data: action.payload,
      }
    case actions.FETCH_ALL_EMAIL_TEMPLATE:
      // console.log('action--->', action.payload)
      return {
        ...state,
        data: action.payload?.templateList,
        totalCount: action.payload?.totalCount,
      }
    case actions.HANDLE_PAGINATION:
      return {
        ...state,
        pagination: action.payload,
      }
    case actions.FETCH_TEMPLATE_TYPE:
      return {
        ...state,
        templateType: action?.payload,
      }
    default:
      return state
  }
}

export default fetchEmailTemplateState
